__turbopack_context__.v({
  "checkbox": "WJNEfq_checkbox",
  "content": "WJNEfq_content",
  "description": "WJNEfq_description",
  "header": "WJNEfq_header",
  "item": "WJNEfq_item",
  "itemLabel": "WJNEfq_itemLabel",
  "items": "WJNEfq_items",
  "printButton": "WJNEfq_printButton",
  "progress": "WJNEfq_progress",
  "root": "WJNEfq_root",
  "title": "WJNEfq_title",
});
